export default __webpack_public_path__ + "static/ru-1-d149ddfee949eb2345cff5c60a3b7ab4.svg";